"use client";
import { useState } from "react";
import { useThreeLevelSelector } from "./useThreeLevelSelector";
import { IoTrashOutline } from "react-icons/io5"; // Importa el ícono de cerrar

export const SearchArea = ({ data }) => {
  let { handleOnChangeLevel1, handleOnChangeLevel2, handleOnChangeLevel3 } =
    useThreeLevelSelector();
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setIsDropdownVisible(true); // Mostrar el desplegable cuando se ingrese texto
  };

  const handleItemClick = ({ index, label }) => {
    setSearchTerm(label); // Actualizamos el input con el valor del elemento clickeado
    handleOnChangeLevel1(Math.floor(index / 100) * 100); // Actualizamos el valor del primer selector
    handleOnChangeLevel2(Math.floor(index / 10) * 10); // Actualizamos el valor del segundo selector
    handleOnChangeLevel3(index); // Actualizamos el valor del tercer selector
    setIsDropdownVisible(false); // Ocultamos el desplegable
  };

  const clearInput = () => {
    setSearchTerm(""); // Limpia el input
    setIsDropdownVisible(false); // Oculta el desplegable
  };

  const normalizeText = (text) => {
    return text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };
  // Función para filtrar los datos
  const searchFilteredData = data.filter((item) =>
    normalizeText(item.label).includes(normalizeText(searchTerm))
  );

  return (
    <>
      <div className="w-full md:w-4/12 relative">
        <input
          type="text"
          placeholder="Buscar por área..."
          value={searchTerm}
          onChange={handleInputChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 mb-4"
        />
        {searchTerm && (
          <IoTrashOutline
            className="absolute right-3 top-3 text-gray-500 text-xl cursor-pointer"
            onClick={clearInput}
          />
        )}
        {searchTerm.length > 0 && isDropdownVisible && (
          <ul className="divide-y divide-gray-200 bg-white shadow-lg p-4 max-h-60 absolute z-50 w-full left-0 top-full mt-2 overflow-y-auto rounded-lg">
            {searchFilteredData.length > 0 ? (
              searchFilteredData.map((item) => (
                <li
                  key={item.index}
                  className="py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleItemClick(item)} // Al hacer clic, seleccionamos el valor y ocultamos el desplegable
                >
                  {item.label}
                </li>
              ))
            ) : (
              <li className="py-2 text-red-500">
                No se encontraron resultados
              </li>
            )}
          </ul>
        )}
      </div>
    </>
  );
};
